import { render } from "./List.vue?vue&type=template&id=18f51601"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
script.render = render

export default script